import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { NgModule, Injector, DoBootstrap } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { EcommerceConfigService } from 'idt-ecommerce-api/config/ecommerce-config.service';
import { ContextService } from 'idt-ecommerce-api/context/context.service';
import { IdtEcommerceApiModule } from 'idt-ecommerce-api/idt-ecommerce-api.module';
import { SegmentationService } from 'shared/services/segmentation.service';

import { RenderPageModule } from './render-page.module';
import { RenderComponent } from './render.component';
import { CookieService } from './services/render-cookies.service';


registerLocaleData(localeEs, 'es-ES');


@NgModule({
  imports: [
    RouterModule.forRoot([], {}),
    StoreModule.forRoot({}),
    BrowserAnimationsModule,
    RenderPageModule,
    IdtEcommerceApiModule,
  ],
  exports: [
    RenderComponent,
    RouterModule
  ],
  declarations: [
    RenderComponent
  ],
  providers: [
    ContextService,
    EcommerceConfigService,
    SegmentationService,
    CookieService
  ]
})
export class RenderWebComponentModule implements DoBootstrap {

  constructor(private readonly injector: Injector) {}

  public ngDoBootstrap(): void {
    const el = createCustomElement(RenderComponent, { injector: this.injector });
    customElements.define('render-idt', el);
  }

}
